import _ from 'lodash';
import {Box, ColumnLayout, Container, Grid, Header, Popover, PopoverProps, SpaceBetween, Table, Tabs} from '@amzn/awsui-components-react';
import ExpandableSection from '@amzn/awsui-components-react/polaris/expandable-section';
import React from 'react';
import {RouteComponentProps} from 'react-router-dom';
import { PropertyList } from '../../PropertyList';
import { ExclusionGroupDefinition } from '../../../backend/model';
import { DynamicHookPopover, isDynamicHook } from '../DynamicHookPopover';
import { WildcardPopover, isWildcard } from '../WildcardPopover';

interface ExclusionGroupDetailsPanelProps extends RouteComponentProps {
    exclusionGroupName: string,
    exclusionGroup: ExclusionGroupDefinition,
}

const ExclusionGroupDetailsPanel: React.FC<ExclusionGroupDetailsPanelProps> = ({exclusionGroupName, exclusionGroup}) => {
    const exclusionGroupAttributes = _.keys(exclusionGroup)

    const parseExclusionGroupValue = (value: string) => {
        if (isDynamicHook(value)) {
            return <DynamicHookPopover value={value} />
        } else if (isWildcard(value)) {
            return <WildcardPopover>{value}</WildcardPopover>
        } else {
            return value
        }
    }

    const summary = (
        <ColumnLayout columns={2} variant="text-grid">
            <SpaceBetween size="l">
                <div className='nameContainer'>
                    <Box variant="awsui-key-label">Name</Box>
                    <div>{exclusionGroupName}</div>
                </div>
            </SpaceBetween>
            <SpaceBetween size="l">
                <div className='attributesExcludedOnContainer'>
                    <Box variant="awsui-key-label">Attributes Excluded On</Box>
                    <PropertyList items={exclusionGroupAttributes} />
                </div>
            </SpaceBetween>
        </ColumnLayout>
    )

    const excludesOnSection = (attribute: string, index: number) => (
        <React.Fragment key={index}>
            <ExpandableSection
                id={attribute}
                className="excludesOnSectionContainer"
                variant='container'
                header={<Header variant='h2'>Values Excluded On: {attribute}</Header>}
                defaultExpanded>
                <PropertyList items={exclusionGroup[attribute].map(parseExclusionGroupValue)} />
            </ExpandableSection>
            <br/>
            <br/>
        </React.Fragment>
    )

    return (
        <div>
            <ExpandableSection
                id='exclusionGroupSummaryPanel'
                variant='container'
                header={<Header variant='h2'>Exclusion Group Summary</Header>}
                defaultExpanded>
                {summary}
            </ExpandableSection>
            <br/>
            <br/>
            {exclusionGroupAttributes.map(excludesOnSection)}
        </div>
    );
};

export default ExclusionGroupDetailsPanel;
